<template>
	<div>
		<v-list-item :selectable="false">
			<v-text-field
				v-model="filter"
				placeholder="Filter name"
				hide-details
				single-line
				clearable
				dense
			/>
		</v-list-item>

		<v-list-item-group v-model="$selected">
			<v-list-item
				v-for="item in items"
				:key="item.id"
				:value="item.id"
				:style="{ display: display(item) }"
			>
				<v-list-item-content>
					<v-list-item-title>{{ item.name }}</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list-item-group>
	</div>
</template>

<script>
import _ from "lodash";

import strings from "@/utils/strings";

export default {
	props: {
		items: { type: Array, required: true, default: () => [] },
		selected: { type: Number, required: false, default: null },
	},

	data: () => ({
		strings: strings.project.accessGroups,

		filter: null,
	}),

	computed: {
		$selected: {
			get() {
				return this.selected;
			},
			set(value) {
				this.$emit("update:selected", value);
			},
		},

		showActions() {
			return !_.isNil(this.selected);
		},
	},

	methods: {
		display(item) {
			if (
				!_.isEmpty(this.filter) &&
				!_.includes(_.toLower(item.name), _.toLower(this.filter))
			)
				return "none";
		},
	},
};
</script>
